<template>
  <div class="p-system-status">
    <page-title>Clinical / External Systems</page-title>

    <section-block>
      <template slot="header">
        <filter-bar
          resource="systems"
          :search-query="searchQuery"
          show-search
          action="listExternal"
        ></filter-bar>
      </template>
      <template slot="actions" v-if="$route.meta.isAdmin">
        <base-button
          :primary="true"
          iconBefore="plus-circle"
          @click="onClickAdd"
          >Add System</base-button
        >
      </template>
      <div v-if="!loading">
        <vuetable
          class="c-data-table"
          :fields="table.fields"
          :api-mode="false"
          :data-manager="dataManager"
          pagination-path
          @vuetable:pagination-data="onPaginationData"
          @vuetable:row-clicked="onRowClick"
          ref="systemsTable"
          no-data-template="<br>No external systems were found.<br><br>"
        >
          <template slot="system-status" slot-scope="props">
            <div class="c-data-table__cell-icon">
              <system-icon :system="props.rowData"></system-icon>
            </div>
          </template>

          <template slot="last-updated" slot-scope="props">
            <div class="c-data-table__cell-icon">
              {{
                $dayjs(
                  props.rowData.modified_time || props.rowData.created_time
                ).format('DD / MM / YYYY HH:mm:ss')
              }}
            </div>
          </template>

          <template slot="homepage" slot-scope="props">
            <div class="c-data-table__cell-icon">
              {{ props.rowData.homepage ? 'Yes' : 'No' }}
            </div>
          </template>

          <template slot="actions" slot-scope="props">
            <div>
              <base-button
                v-if="$route.meta.isAdmin"
                @click="onClickUpdate(props.rowData.id)"
                >Update</base-button
              >
              <base-button
                v-if="!props.rowData.user_favourite && !$route.meta.isAdmin"
                @click="onClickFollow(props.rowData.id)"
                asLink
              >
                <icon name="view" color="#768692" />
              </base-button>
              <base-button
                v-else-if="props.rowData.user_favourite && !$route.meta.isAdmin"
                @click="onClickUnfollow(props.rowData.id)"
                asLink
              >
                <icon name="view" color="#005eb8" />
              </base-button>
            </div>
          </template>
        </vuetable>
        <pagination table-pagination>
          <vuetable-pagination
            ref="pagination"
            @vuetable-pagination:change-page="onChangePage"
          ></vuetable-pagination>
        </pagination>
      </div>
      <loading v-else></loading>
    </section-block>
  </div>
</template>

<script>

import { mapState } from 'vuex'
import querySearch from "@/mixins/querySearch";
import Pagination from '@/components/pagination'
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'

import SystemIcon from '@/components/SystemIcon'

export default {
  name: 'system-status',

  props: ['tabFilter'],

  mixins: [querySearch],

  data() {
    return {
      showFollowing: false,
      loading: true,
      searchQuery: '',
      table: {
        fields: [
          {
            name: 'name',
            title: 'System',
            titleClass: 'u-ta-left',
            width: '30%'
          },
          {
            name: 'link',
            title: 'Link',
            titleClass: 'u-ta-left',
            width: '30%'
          },
          {
            name: 'homepage',
            title: 'Show on Homepage',
            titleClass: 'u-ta-left',
            width: '30%'
          },
          {
            name: 'actions',
            title: 'Actions',
            titleClass: 'u-ta-center',
            dataClass: 'u-ta-center',
            width: '10%'
          }
        ]
      }
    }
  },

  created() {
    this.listSystems(true)
    if (!this.$route.meta.isAdmin) {
      //don't need the last 2 columns for non-admin view
      this.table.fields = this.table.fields.filter((field, index) => index <= 2)
    }
  },

  methods: {
    updateTable() {
      this.$refs.systemsTable.refresh()
    },
    dataManager(sortOrder, pagination) {
      const returnObj = {
        ...this.$store.state.systems.pagination,
        data: this.externalSystems
      }

      return returnObj
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
    },
    onChangePage(page) {
      const vm = this
      const tableref = vm.$refs.systemsTable
      let nextPage
      this.loading = true

      switch (page) {
        case 'next':
          nextPage = ++this.$store.state.systems.pagination.current_page
          break
        case 'prev':
          nextPage = --this.$store.state.systems.pagination.current_page
          break
        default:
          nextPage = page
          break
      }
      
      this.$store
        .dispatch('systems/listExternal', { forceUpdate: true, page: nextPage })
        .then(resp => {
          window.scroll(0, 0)
          tableref.changePage(nextPage)
          this.loading = false
        })
    },
    //view the status list
    onRowClick(row) {
      if (this.$route.meta.isAdmin && row.even.target.localName === 'td') {
        this.$router.push({
          name: 'AdminEditExternalSystem',
          params: { id: row.data.id }
        })
      } else {
        window.open(row.data.link)
      }
    },

    onClickAdd() {
      this.$router.push({ name: 'AdminAddExternalSystem' })
    },
    onClickUpdate(id) {
      this.$router.push({ name: 'AdminEditExternalSystem', params: { id } })
    },
    listSystems(loading) {
      this.$store.commit('systems/SET_EXTERNAL_SYSTEMS', [])
      this.setFiltersFromQuery('systems')
      this.$store
        .dispatch('systems/listExternal', { forceUpdate: true })
        .then(resp => {
          this.loading = false
        })
    },

    onClickDelete(systemId) {
      this.$store.dispatch('systems/delete', systemId)
    },
    onClickFollow(systemId) {
      this.$store.dispatch('systems/favourite', systemId)
      this.listSystems(false)
    },
    onClickUnfollow(systemId) {
      this.$store.dispatch('systems/unfavourite', systemId)
      this.listSystems(false)
    }
  },

  computed: {
    ...mapState('systems', ['externalSystems'])
  },

  watch: {
    externalSystems: {
      immediate: false,
      deep: true,
      handler(newValue, oldValue) {
        this.updateTable()
      }
    }
  },

  components: {
    SystemIcon,
    Pagination,
    VuetablePagination
  }
}
</script>

<style lang="scss" scoped>
.svg-icon {
  width: 50px;
}
</style>
